import React, { createContext, useContext, useState } from "react";

const TransactionNotificationContext = createContext();

export const TransactionNotificationProvider = ({ children }) => {
  const [transactionNotification, setTransactionNotification] = useState(0);

  return (
    <TransactionNotificationContext.Provider value={{ transactionNotification, setTransactionNotification }}>
      {children}
    </TransactionNotificationContext.Provider>
  );
};

export const useTransactionNotification = () => useContext(TransactionNotificationContext);
